/**
 * Provides the selection and save logic needed by the actPhotoUpload directive
 */
export class PhotoUploadController {
  public static $inject = ['Upload'];
  public result;
  public croppedPhoto;
  public finalImage;
  public image;
  public progress;
  public originalPhoto;
  public okCallback: Function;
  public photoSettings = {
    size: { min: 10, max: '20MB' },
    width: { min: 132, max: 132 },
    height: { min: 132, max: 132 },
    ratio: '5x3',
    pattern: 'image/*'
  };

  constructor(private Upload) {
    this.finalImage = this.image;
  }

  /**
   * Clears the finalImage and progress property values
   */
  public selectPhoto = () => {
    this.finalImage = undefined;
    this.progress = undefined;
  }

  /**
   * Sets the value of finalImage to the selected\cropped photo from the user
   *
   * @param data The data of the image we wish to upload
   */
  public savePhoto = (data) => {
    const dataBlob = this.Upload.dataUrltoBlob(data);
    this.okCallback(dataBlob, this.originalPhoto.name);
    this.finalImage = this.croppedPhoto;
  }
}